





















































import { getInvoiceXls, invoiceController } from '@/api/Agency/agency.api'
import IconButton from '@/components/IconButton.vue'
import { tableComposition } from '@/compositions/table'
import vRules from '@/utils/vRules'
import { defineComponent, ref } from '@vue/composition-api'
import { Invoice } from '~/api/Agency/agency.interface'
import InvoicePdfButton from '~/components/Agency/Invoices/InvoicePdfButton.vue'
import InvoicesCrudDialog from '~/components/Agency/Invoices/InvoicesCrudDialog.vue'
import InvoiceSendButton from '~/components/Agency/Invoices/InvoiceSendButton.vue'
import InvoicesFilter from '~/components/Agency/Invoices/InvoicesFilter.vue'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'
import { generateFile } from '~/utils/functions'

export default defineComponent({
  components: {
    IconButton,
    InvoicesCrudDialog,
    InvoicePdfButton,
    InvoicesFilter,
    InvoiceSendButton,
    FlatCard,
    TextButton,
    FlatTable,
  },
  setup(_, { root }) {
    const composition = tableComposition(invoiceController)

    const onGenerateExcel = async () => {
      composition.tableLoading.value = true
      try {
        const filters = composition.table.value?.lastFilter
        const response = await getInvoiceXls(filters)
        generateFile(
          response,
          root.$t('invoices') + new Date().toLocaleDateString() + '.xls',
        )
      } finally {
        composition.tableLoading.value = false
      }
    }

    return {
      ...composition,
      vRules,
      onGenerateExcel,
      async onCopy(item: Invoice) {
        // @ts-expect-error undefined uuid
        composition.editedItem.value = { ...item, uuid: undefined }
        composition.dialogModel.value = true
      },
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('code'),
          value: 'code',
          notShow: !this.$p.isSuperuser,
        },
        {
          text: this.$t('agency.agency'),
          value: 'agency_name',
          notShow: !this.$p.isSuperuser,
        },
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('email'),
          value: 'email',
        },
        {
          text: this.$t('phone'),
          value: 'phone',
        },
        {
          text: this.$t('address'),
          value: 'full_address',
        },
        {
          text: this.$t('amount'),
          value: 'amount',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ],
    }
  },
})
